var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 37,
    viewBox: "0 0 30 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66934 1.08005L7.89944 0.179905C8.96549 -0.116703 10.1119 -0.0447374 11.1247 0.382378C12.1376 0.809493 12.9478 1.56259 13.4041 2.50118L15.6687 7.15606C16.0617 7.96361 16.1713 8.86466 15.982 9.7327C15.7927 10.6007 15.314 11.3922 14.6131 11.9959L11.1662 14.9645C10.7043 15.3699 11.0545 16.9498 12.7421 19.6533C14.4314 22.3584 15.7371 23.4281 16.3391 23.2616L20.8549 21.9854C21.7702 21.7266 22.7503 21.7391 23.6576 22.021C24.5649 22.3029 25.354 22.8402 25.9143 23.5576L29.1328 27.6807C29.7828 28.5133 30.0838 29.5357 29.9799 30.5579C29.8759 31.5802 29.374 32.5328 28.5674 33.2388L26.0794 35.4167C25.2762 36.1198 24.2857 36.6133 23.2088 36.847C22.1318 37.0807 21.0071 37.0462 19.9494 36.7469C14.7365 35.2719 9.90888 30.8944 5.4014 23.6763C0.883925 16.4473 -0.82201 10.3497 0.366975 5.36809C0.606781 4.36429 1.13188 3.43777 1.88814 2.68403C2.6444 1.93029 3.60445 1.3766 4.66934 1.08005V1.08005Z",
    fill: "#0FA958"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.c4b6b01b748d794ffd6d93dc4a8d4109.svg";
export { ForwardRef as ReactComponent };